'use strict';

/**
 * Recently viewed products.
 *
 * Tracks viewed product ids in localStorage and fills every
 * `.product-recently-viewed` element via the section rendering API
 * (`search?section_id=...&q=id:1 OR id:2`).
 *
 * The element's data-url is locale-relative: Shopify.routes.root
 * ('/' or '/en/') is prepended at fetch time, so history written in one
 * locale renders correctly in any other.
 */
function btyRecentlyProduct( doc = document ) {
	let holders = doc.querySelectorAll( '.product-recently-viewed' );
	if ( 'undefined' === typeof( Storage ) || ! holders.length ) {
		return;
	}

	const STORAGE_KEY = 'recently-viewed';
	const MAX_ITEMS   = 12; // ids kept in history; old entries fall off the end.

	let current = btyGlobals.last_product_id;
	let history = [];

	try {
		history = JSON.parse( localStorage.getItem( STORAGE_KEY ) ) || [];
	} catch ( e ) {
		history = [];
	}

	if ( ! Array.isArray( history ) ) {
		history = [];
	}

	// Numbers only — a corrupted store must not end up in the search query.
	history = history.filter( function( id ) {
		return Number.isFinite( Number( id ) ) && Number( id ) > 0;
	} );

	// Most recent first, deduplicated, capped.
	if ( current ) {
		history = history.filter( function( id ) {
			return Number( id ) !== Number( current );
		} );
		history.unshift( current );
		history = history.slice( 0, MAX_ITEMS );
	}

	localStorage.setItem( STORAGE_KEY, JSON.stringify( history ) );

	// Never suggest the product being looked at.
	let others = history.filter( function( id ) {
		return Number( id ) !== Number( btyGlobals.is_product );
	} );

	if ( ! others.length ) {
		return;
	}

	let query = others.map( function( id ) {
		return 'id:' + id;
	} ).join( ' OR ' );

	let root = ( window.Shopify && window.Shopify.routes && window.Shopify.routes.root ) || '/';

	holders.forEach( function( holder ) {
		let path    = holder.getAttribute( 'data-url' ),
			section = holder.closest( '.shopify-section' );

		if ( ! path || ! section ) {
			return;
		}

		// Tolerate both the current relative form ("search?...") and the old
		// absolute form ("/search?...") in case a stale cached page pairs old
		// markup with this script.
		let url = window.location.origin + root + path.replace( /^\/+/, '' ) + encodeURIComponent( query );

		fetch( url )
			.then( function( response ) {
				if ( 200 !== response.status ) {
					throw new Error( 'Recently viewed: status ' + response.status );
				}

				return response.text();
			} )
			.then( function( text ) {
				let fresh = new DOMParser().parseFromString( text, 'text/html' ).querySelector( '.product-recently-viewed' );

				if ( fresh && fresh.innerHTML.trim() ) {
					holder.innerHTML = fresh.innerHTML;
					section.classList.add( 'has-products-recently' );

					btyAddToCart( holder );
					btyCarousel( holder );
					btyQuickView( holder );
					btySwatch( holder );
					btyQuickAdd( holder );
					btyAnimationImageLoad( holder );
					btyHoverMediaVideo( holder );

					holder.removeAttribute( 'data-url' );
					document.dispatchEvent( new CustomEvent( 'product-card-updated' ) );
				} else {
					section.classList.remove( 'has-products-recently' );
				}
			} )
			.catch( function( error ) {
				console.log( error );
			} );
	} );
}

document.addEventListener( 'DOMContentLoaded', function() {
	btyRecentlyProduct();
} );

document.addEventListener( 'shopify:section:load', function( event ) {
	let section = event.target.closest( 'section.shopify-section' );

	setTimeout( function() {
		btyRecentlyProduct( section );
	} );
} );

document.addEventListener( 'shopify:section:select', function( event ) {
	btyRecentlyProduct( event.target );
} );
